// CountryOptions.js
import React from 'react';

const CurrencyOptions = () => {
  return (
    <>
      <option value="KES">KES</option>
      <option value="USD">USD</option>
    </>
  );
}

export default CurrencyOptions;
